export function getComplaintStatus(stateValue) {
  const statusMap = {
    0: { status: "Opened", textColor: "text-yellow-500" },
    1: { status: "Resolved", textColor: "text-green" },
    "-1": { status: "Rejected", textColor: "text-red-1" },
  };

  return statusMap[stateValue] || "";
}

export function getVisitStatus(stateValue) {
  const statusMap = {
    0: { status: "Pending", textColor: "text-yellow-500" },
    1: { status: "Approved", textColor: "text-green" },
    "-1": { status: "Rejected", textColor: "text-red-1" },
  };

  return statusMap[stateValue] || "";
}



export function getVehicleReadingStatus(stateValue) {
  const statusMap = {
    0: { status: "Pending", textColor: "text-yellow-500" },
    1: { status: "Approved", textColor: "text-green" },
    "-1": { status: "Rejected", textColor: "text-red-1" },
  };

  return statusMap[stateValue] || "";
}
